export default __webpack_public_path__ + "static/media/notice_calendar_icon.c3a06c98.svg";